import React from "react";

const Error404 = () => {
    return (
        <div style={{padding: "40px"}} className="error-404">404-страница не найдена</div>
    );
};
export default Error404;